import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useMemo } from 'react';
import { useUncontrolled } from '../use-uncontrolled/use-uncontrolled.js';
import { range } from '../utils/range/range.js';
var DOTS = "dots";

function usePagination(_ref) {
  var total = _ref.total,
      _ref$siblings = _ref.siblings,
      siblings = _ref$siblings === void 0 ? 1 : _ref$siblings,
      _ref$boundaries = _ref.boundaries,
      boundaries = _ref$boundaries === void 0 ? 1 : _ref$boundaries,
      page = _ref.page,
      _ref$initialPage = _ref.initialPage,
      initialPage = _ref$initialPage === void 0 ? 1 : _ref$initialPage,
      onChange = _ref.onChange;

  var _useUncontrolled = useUncontrolled({
    value: page,
    onChange: onChange,
    defaultValue: initialPage,
    finalValue: initialPage,
    rule: function rule(_page) {
      return typeof _page === "number" && _page <= total;
    }
  }),
      _useUncontrolled2 = _slicedToArray(_useUncontrolled, 2),
      activePage = _useUncontrolled2[0],
      setActivePage = _useUncontrolled2[1];

  var setPage = function setPage(pageNumber) {
    if (pageNumber <= 0) {
      setActivePage(1);
    } else if (pageNumber > total) {
      setActivePage(total);
    } else {
      setActivePage(pageNumber);
    }
  };

  var next = function next() {
    return setPage(activePage + 1);
  };

  var previous = function previous() {
    return setPage(activePage - 1);
  };

  var first = function first() {
    return setPage(1);
  };

  var last = function last() {
    return setPage(total);
  };

  var paginationRange = useMemo(function () {
    var totalPageNumbers = siblings * 2 + 3 + boundaries * 2;

    if (totalPageNumbers >= total) {
      return range(1, total);
    }

    var leftSiblingIndex = Math.max(activePage - siblings, boundaries);
    var rightSiblingIndex = Math.min(activePage + siblings, total - boundaries);
    var shouldShowLeftDots = leftSiblingIndex > boundaries + 2;
    var shouldShowRightDots = rightSiblingIndex < total - (boundaries + 1);

    if (!shouldShowLeftDots && shouldShowRightDots) {
      var leftItemCount = siblings * 2 + boundaries + 2;
      return [].concat(_toConsumableArray(range(1, leftItemCount)), [DOTS], _toConsumableArray(range(total - (boundaries - 1), total)));
    }

    if (shouldShowLeftDots && !shouldShowRightDots) {
      var rightItemCount = boundaries + 1 + 2 * siblings;
      return [].concat(_toConsumableArray(range(1, boundaries)), [DOTS], _toConsumableArray(range(total - rightItemCount, total)));
    }

    return [].concat(_toConsumableArray(range(1, boundaries)), [DOTS], _toConsumableArray(range(leftSiblingIndex, rightSiblingIndex)), [DOTS], _toConsumableArray(range(total - boundaries + 1, total)));
  }, [total, siblings, activePage]);
  return {
    range: paginationRange,
    active: activePage,
    setPage: setPage,
    next: next,
    previous: previous,
    first: first,
    last: last
  };
}

export { DOTS, usePagination };